import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { Directive } from "@angular/core";

@Directive()
export abstract class BaseDatasource<T> implements DataSource<T> {
    public totalItems = 0;
    public itemsPerPage = 0;

    protected loadingSubject = new BehaviorSubject<boolean>(false);
    // eslint-disable-next-line
    public loading$ = this.loadingSubject.asObservable();

    subject = new BehaviorSubject<T[]>([]);

    /* eslint-disable */
    public connect(collectionViewer: CollectionViewer | null = null): Observable<T[]> {
        return this.subject.asObservable();
    }

    public disconnect(collectionViewer: CollectionViewer): void {
      this.subject.complete();
      this.loadingSubject.next(false);
      this.loadingSubject.complete();
    }
    /* eslint-enable */

    /**
     * Replace the loading subject
     *
     * @param loadingSubject
     */
    public setLoadingSubject(loadingSubject: BehaviorSubject<boolean>): void {
        if (loadingSubject) {
            this.loadingSubject = loadingSubject;
        }
    }
}
